import { getAudioParamConnections } from './get-audio-param-connections';
export function getAudioParamRenderer(context, audioParam) {
  var audioParamConnections = getAudioParamConnections(context, audioParam);

  if (audioParamConnections.renderer === null) {
    throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
  }

  return audioParamConnections.renderer;
}